import { Injectable } from '@angular/core';
import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { VrEvent } from '../models/vr-events/VrEvent';
import { NgForm } from '@angular/forms';
import { EventType } from '../models/vr-events/EventType';
import { EventTrigger } from '../models/vr-events/EventTrigger';
import { MovementEvent } from '../models/vr-events/MovementEvent';
import { API_SETTINGS } from './API_SETTINGS';
import { SceneEvent } from '../models/vr-events/SceneEvent';
const httpOptions = {
  headers: new HttpHeaders({'Content-Type': 'application/json'})
};

const apiUrl = API_SETTINGS.API_URL + 'VrEvent';

@Injectable({
  providedIn: 'root'
})
export class ApiVrEventService {
  
  constructor(private http: HttpClient) { }

  private handleError<T> (operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {
  
      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead
  
      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  getVrEvents (): Observable<VrEvent[]> {
    const url = apiUrl +'/GetVrEvents'
    return this.http.get<VrEvent[]>(url).pipe();
  }
  
  getVrEvent(id: number): Observable<VrEvent> {
    const url = `${apiUrl}/GetVrEvent/${id}`;
    return this.http.get<VrEvent>(url).pipe();
  }

  getVrEventTypes(): Observable<EventType[]> {
    const url = apiUrl +'/GetVrEventTypes'
    return this.http.get<EventType[]>(url).pipe();
  }

  getVrEventTriggers(): Observable<EventTrigger[]> {
    const url = apiUrl +'/GetVrEventTriggers'
    return this.http.get<EventTrigger[]>(url).pipe();
  }


  addVrEvent(VrEvent: VrEvent): Observable<VrEvent>{  
    const url = apiUrl +'/PostVrEvent'
    return this.http.post<VrEvent>(url, VrEvent, httpOptions).pipe();
  }

  addSceneEvent(event: SceneEvent): Observable<SceneEvent> {
    const url = apiUrl +'/PostSceneEvent'
    return this.http.post<SceneEvent>(url, event, httpOptions).pipe();
  }

  addMovementEvent(MovementEvent: MovementEvent): Observable<MovementEvent>{  
    const url = apiUrl +'/PostMovementEvent'
    return this.http.post<MovementEvent>(url, MovementEvent, httpOptions).pipe();
  }
  
  updateVrEvent (id: number, VrEvent: any): Observable<VrEvent>{
     const url = `${apiUrl}/PutVrEvent/${id}`;
    return this.http.put(url, VrEvent, httpOptions).pipe(
      tap((VrEventRes: VrEvent) => true ), //console.log()),
      catchError(this.handleError<VrEvent>('updateVrEvent'))
    )
  }
 
  updateSceneEvent(id: any, sceneEvent: SceneEvent): Observable<SceneEvent> {
    const url = `${apiUrl}/PutSceneEvent/${id}`;
    return this.http.put(url, sceneEvent, httpOptions).pipe(
      tap((sceneEventRes: SceneEvent) => true ), //console.log()),
      catchError(this.handleError<SceneEvent>('updateSceneEvent'))
    )
  }
 

  updateMovementEvent (id: number, MovementEvent: any): Observable<MovementEvent>{
    const url = `${apiUrl}/PutMovementEvent/${id}`;
   return this.http.put(url, MovementEvent, httpOptions).pipe(
     tap((MovementEventRes: MovementEvent) => true ), //console.log()),
     catchError(this.handleError<MovementEvent>('updateMovementEvent'))
   )
 }

  deleteVrEvent(id: number): Observable<VrEvent> {
    const url = `${apiUrl}/DeleteVrEvent/${id}`;
    return this.http.delete<VrEvent>(url, httpOptions).pipe();
  }

}
